import React from "react";

import { ReactComponent as Business } from "../../../assets/novosicones/notificacoes/aniversario.svg";

const Aniversario = ({ tema }) => {
  const NOTIFICATIONSANIVERSARIO = JSON.parse(
    sessionStorage.getItem("notificationsAniversario")
  );

  let checkIfNewDestaque = [];

  if (NOTIFICATIONSANIVERSARIO?.length > 0)
    checkIfNewDestaque = NOTIFICATIONSANIVERSARIO.filter((item) => {
      return !item.Visualizado;
    });

  if (checkIfNewDestaque.length == 0) return null;

  return (
    <div className="notifications__item" style={{ marginTop: "24px" }}>
      <span
        className="notifications__item__title"
        style={{ color: tema.primaryColor }}
      >
        Aniversário:
      </span>
      {NOTIFICATIONSANIVERSARIO.length > 0 && (
        <div className="centralized-space-between">
          <div className="centralized">
            <span style={{ width: "24px", height: "24px", display: "block" }}>
              <Business style={{ fill: tema.primaryColor }} />
            </span>
            <p
              className="notifications__item__description"
              style={{ color: "#454545" }}
            >
              Feliz aniversário! Te desejamos muitos anos de vida, muita saúde e
              momentos bons com quem você ama. Conte sempre conosco, aproveite
              seu dia com seu melhor sorriso!
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Aniversario;
